import React from 'react';
import { Comment } from '../../store/config/types/comment.types';
import { Grid } from '@mui/material';

interface CommentBlobProps {
  comment: Comment;
  isOwner?: boolean;
}

function CommentBlob({ comment, isOwner }: CommentBlobProps) {
  return (
    <Grid container flexDirection={'column'} ml={isOwner ? undefined : 2} mb={2} maxWidth={600}>
      <Grid item>
        <Grid container alignItems={'center'}>
          {!isOwner && (
            <Grid item mr={2}>
              {comment.displayName}
            </Grid>
          )}
          <Grid item style={{ fontSize: '70%', color: 'gray' }}>
            {comment.timestamp}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid
            item
            p={2}
            style={{
              backgroundColor: isOwner ? 'rgba(150,150,150,0.1)' : 'rgba(0,150,0,0.1)',
              borderRadius: 20,
              borderLeft: comment.isNew ? '4px solid skyblue' : undefined,
              borderTopLeftRadius: isOwner ? 20 : 0,
              borderBottomLeftRadius: isOwner ? 0 : 20,
            }}
          >
            {comment.text}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default React.memo(CommentBlob, (prev, next) => {
  let eq = prev.comment.commentId == next.comment.commentId;
  eq &&= prev.isOwner == next.isOwner;
  return eq;
});
